import EventEmitter from '../../helpers/EventEmmiter';
import TranslateService from '../../service/e3.viewer.translate.service';
import ModalService from '../../service/modal/e3.viewer.modal.service';

require('./floor-select.scss');

export default class FloorSelect extends EventEmitter {
    _options = {};
    _container = {};
    _elements = {};
    _controls = {};
    _mode = {
        current: 0,
        values: ['select','edit']
    };
    _mapping = {
        edit: {
            container: 'e3-floor-select__edit',
        },
        select: {
            container: 'e3-floor-select__input',
        }
    };
    _template = require('./floor-select.html');

    constructor(container, opt, e3plan_max_floors) {
        super();

        ({options: this._options} = opt);
        this._container = container;
        this._e3plan_max_floors = e3plan_max_floors;

        this._init();
    }

    _addOption(option, i = null) {
        i = i === null ? this._elements.select.options.length : i;
        this._elements.select.options[i] = new Option(option.name, option.id, false, false);
    }

    _bindActions(name) {
        let control = this._controls[name];
        if (!control) return;

        for (let i in control.events) {
            if (control.events.hasOwnProperty(i)) {
                control.element.addEventListener(i, control.events[i]);
            }
        }
    }

    _getMode() {
        return this._mode.values[this._mode.current];
    }

    _init() {
        this._initContainer();
        this._initOptions();
        this._initdActions();
        this._translateService = new TranslateService();
        this._modalService = new ModalService(this._container, this._translateService);
        // if(this._options.length < 2) this._hide(this._elements.delete);
    }

    _show(element) {
        element.classList.remove('hide');
    }
    _hide(element) {
        element.classList.add('hide');
    }
    _initContainer() {
        this._container.innerHTML = this._template;

        this._elements.selectContainer = this._container.querySelector(`.${this._mapping.select.container}`);
        this._elements.editContainer = this._container.querySelector(`.${this._mapping.edit.container} `);
        this._elements.input = this._elements.editContainer.querySelector(`input`);
        this._elements.confirm = this._elements.editContainer.querySelector(`.confirm`);
        this._elements.cancel = this._elements.editContainer.querySelector(`.cancel`);
        this._elements.select = this._elements.selectContainer.querySelector(`select`);
        this._elements.edit = this._elements.selectContainer.querySelector(`.edit`);
        // this._elements.delete = this._elements.selectContainer.querySelector(`.delete`);

        this._setMode('select');
    }

    _initControl(name, element, actions = {}) {
        let control = {element, events: {}};

        this._controls[name] = control;
        for (let i in actions) {
            if (actions.hasOwnProperty(i)) {
                control.events[i] = actions[i];
            }
        }

        this._bindActions(name);
    }

    _initOptions() {
        this._elements.select.options.length = 0;
        this._options.forEach(opt => this._addOption(opt));

        this._addOption({id: '-1', name: 'Add New'});
    }

    _initdActions() {
        // this._initControl('select', this._elements.select, {
        //     'input': this._onSelectChange.bind(this)
        // });
        this._initControl('select', this._elements.select, {
            'change': this._onSelectChange.bind(this)
        });
        this._initControl('select', this._elements.select, {
            'focus': this._onSelectFocus.bind(this)
        });
        this._initControl('edit', this._elements.edit, {
            'click': this._onEditClick.bind(this)
        });
        // this._initControl('delete', this._elements.delete, {
        //     'click': this._onDeleteClick.bind(this)
        // });
        this._initControl('confirm', this._elements.confirm, {
            'click': this._onConfirmClick.bind(this)
        });
        this._initControl('cancel', this._elements.cancel, {
            'click': this._onCancelClick.bind(this)
        });
    }

    _onCancelClick(e) {
        e.preventDefault();
        this._setMode('select');
    }

    _onConfirmClick(e) {
        e.preventDefault();

        let index = this._options.findIndex(opt => opt.id === this._elements.select.value);
        let value = this._elements.input.value;

        if (!~index || !value.replace(' ','')) return;

        this._options[index].name = this._elements.input.value;

        this._initOptions();
        this._setMode('select');
        this._elements.select.value = this._options[index].id;

        this._fireEvent('select.edit', this._options[index]);
    }

    onRenameFloor(data) {

        let index = this._options.findIndex(opt => opt.id === data.id);
        let value = data.name;

        if (!~index || !value.replace(' ','')) return;

        this._options[index].name = value;

        this._initOptions();
        // this._setMode('select');
        this._elements.select.value = this._options[index].id;

        this._fireEvent('select.edit', this._options[index]);
    }

    // _onDeleteClick(e) {
    //     e.preventDefault();
    //     this._fireEvent('select.delete', {id: this._elements.select.value});
    // }

    _onEditClick(e) {
        e.preventDefault();
        // let value = this._options.find(opt => opt.id === this._elements.select.value);
        // this._elements.input.value = value.name;
        // setTimeout(() => this._elements.input.focus(), 0);

        // this._setMode('edit');
        this._fireEvent('toggle.layer.manager');
    }

    _onSelectChange(e) {
        // get previous layer id if it's needed ("-1" if add clicked)
        let prev, value = this._elements.select.value;

        if (value === '-1') {
            let index = Array.from(this._elements.select.options).findIndex(opt => opt.value === value);
            prev = this._elements.select.options[index - 1].value;

            this._fireEvent('select.change', {id: value, prev, isNeedMove: true});
        } else {
          this._elements.select.value = this._lastValue;

          let modal = this._modalService.confirm('This floor will be moved to the selected floor. Agree?', data => {
              if (data) {
                  this._elements.select.value = value;
                  this._fireEvent('select.change', {id: value, prev, isNeedMove: true});
              }

              return this._modalService._removeModal('confirm');
          }, 'floorSelect');
        }
    }

    _onSelectFocus(e) {
        // get previous layer id if it's needed ("-1" if add clicked)
        let prev, value = this._elements.select.value;

        this._lastValue = value;
    }

    _setMode(mode) {
        let index = this._mode.values.indexOf(mode);

        if (!~index) return;
        this._mode.current = index;

        Object.keys(this._mapping).forEach(key => {
            if (!this._mapping[key].container) return;

            let _el = this._container.querySelector(`.${this._mapping[key].container}`);
            if (mode === key)
                _el.classList.remove('hide');
            else
                _el.classList.add('hide');
        });

        return index;
    }

    _unbindActions() {
        for (let control in this._controls) {
            if (this._controls.hasOwnProperty(control)) {
                let _control = this._controls[control];
                for (let event in _control.events) {
                    if (_control.events.hasOwnProperty(event)) {
                        _control.element.removeEventListener(event, _control.events[event]);
                    }
                }
            }
        }
    }

    // todo: destroy instance events
    destroy() {
        this._unbindActions();
    }

    getFloorsCount() {
        return this._options.length
    }

    reinitOptions(options) {
        this._options = options;
        this._initOptions();
        // if(this._options.length > 1){
        //     this._show(this._elements.delete);
        // }else{
        //     this._hide(this._elements.delete);
        // }
    }

    getValue() {
        return this._elements.select.value;
    }

    setValue(value) {
        this._elements.select.value = value;
    }
}
